<template>

    <button class="gallery btn" @click="storeGallerySet(gallery)" >
        View gallery <font-awesome-icon :icon="['fal', 'expand']"  full-width></font-awesome-icon>
    </button>

</template>

<script>
import { mapState, mapMutations } from 'vuex';

export default {
    name: "AccommodationViewGalleryBtn",

    props: {
        gallery: {
            type: Object|Array,
            required: false,
        }
    },

    data() {
        return {
            //abc:null,
        }
    },

    mounted() {

    },

    methods: {

        ...mapMutations('accommodations',['storeGallerySet'])

        //close: function () { },

    },

    computed: {

        //...mapState({

        //loc: state => state.loc,

        //}),

    },

    watch: {
        //show:function(newValue){ }
    },

    //beforeDestroy: function () { }

}
</script>

<style scoped lang="scss">

</style>
